import React, { useContext, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import { authGetRequest } from "../../../api/laravel/public/api";
import { settingContext } from "../../../context/Setting/Setting";
import { _retrieveData, _storeData } from "../../../utils/local-storage";
import Rightbar from "../../../layout/Dashboard/student/rightbar/Rightbar";
import { HeaderText, ModalLayout } from "../../../components";
import {
    StudentSideMenu,
    StudentNotification,
    StudentCourse,
    DashBar,
    EventInfo,
} from "../../../layout/Dashboard";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import moment from "moment";
import { Message } from "@mui/icons-material";

const Inbox = () => {
    const { theme, changeTheme } = useContext(ThemeContext);
    const { page, loading } = React.useContext(settingContext);
    const [user, setUser] = React.useState({});
    const [pageNum, setPageNum] = React.useState(0);
    // const { membership } = React.useContext(MembershipContext);
    const history = useHistory();
    const [data, setData] = React.useState({});
    const [isModal, setModal] = React.useState(false);
    const [event, setEvent] = React.useState({});
    const [inbox, setInbox] = React.useState({});
    const [message, setMessage] = React.useState({});
    const [isPageLoader, setPageLoader] = React.useState(true);

    React.useEffect((e) => {
        checkUser();
        eventsGet();
        dashboardGet();
        getInbox(pageNum);
    }, []);

    const eventsGet = async (e) => {
        const { data_r, isError } = await authGetRequest(`/account/events`);
        if (isError) {
            return false;
        }
        setEvent(data_r);
    };
    const getInbox = async (num) => {
        setPageLoader(true);
        let resp = await authGetRequest(`/account/inbox?page=${num}`);
        setInbox(resp.data_r);
        setPageLoader(false);
    };

    const readMessage = async (id) => {
        setPageLoader(true);
        let resp = await authGetRequest(`/account/inbox/read/${id}`);
        setData(resp.data_r);
        setPageLoader(false);
        setModal(true);
    }

    const setPageOrder = (n) => {
        setPageNum(n);
        getInbox(n)
    }

    const checkUser = async () => {

        let storeUser = await _retrieveData('user_info');
        if (storeUser) {
            setUser(storeUser);
        }
        const { data_r, isLoading, isError } = await authGetRequest("/account/profile");
        if (isError) {
            history.push("/auth/login");
        }
        else {
            await _storeData(data_r, 'user_info');
            setUser(data_r);
        }
    }

    const dashboardGet = async () => {
        setPageLoader(true);
        const { data_r, isError } = await authGetRequest(`/account/dashboard`);
        if (isError) {
            // errorMessage(toast, data_r?.message);
            setPageLoader(false);
            return false;
        }
        setData(data_r);
        setPageLoader(false);
    };

    const showMessage = (e) => {
        setMessage(e);
        document.getElementById('message-ct').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar event={event} inbox={inbox} menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
                <section className="profile-feature">
                    <div className="awe-parallax bg-profile-feature" style={{ backgroundImage: 'url(../img/bg.jpg)' }} />
                    <div className="awe-overlay overlay-color-3" />
                    <div className="container">
                        <div className="info-author">
                            <div className="image">
                                <img src={user?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user.image : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
                            </div>
                            <div className="name-author">
                                <h2 className="big">{user?.first_name} {user?.last_name}</h2>
                            </div>
                            <div className="address-author">
                                <i className="fa fa-map-marker" />
                                <h3>{user?.country}</h3>
                            </div>
                        </div>
                        <div className="info-follow">
                            <div className="trophies">
                                <span>{data?.cert_count}</span>
                                <p>Certificates</p>
                            </div>
                            <div className="trophies">
                                <span>{data?.count_course}</span>
                                <p>Courses</p>
                            </div>
                            <div className="trophies">
                                <span>{data?.count_active_course}</span>
                                <p>Active Course</p>
                            </div>
                            <div className="trophies">
                                <span>{data?.complete_course}</span>
                                <p>Completed Course</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content-bar">
                    <div className="container">
                        <ul style={{ width: '100%' }}>
                            <li >
                                <Link to="/student/home">
                                    <i className="icon mdi mdi-book-open" />
                                    Learning
                                </Link>
                            </li>
                            <li>
                                <Link to="/student/courses">
                                    <i className="icon mdi mdi-note" />
                                    Courses
                                </Link>
                            </li>
                            <li >
                                <Link to="/student/calendar">
                                    <i className="icon mdi mdi-calendar" />
                                    Events
                                </Link>
                            </li>
                            {/* <li>
                <a href="account-assignment.html">
                  <i className="icon mdi mdi-note" />
                  Assignment
                </a>
              </li> */}
                            <li >
                                <Link to="/student/profile">
                                    <i className="icon mdi mdi-account" />
                                    Profile
                                </Link>
                            </li>
                            <li className="current">
                                <Link to="/student/inbox">
                                    <i className="icon mdi mdi-gmail" />
                                    Inbox
                                </Link>
                            </li>
                        </ul>
                    </div>
                </section>
                <section id="course-concern" className="course-concern">
                    <div className="container">
                        <div className="message-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="message-sb">
                                        <div className="message-sb-title">
                                            <h4>Inbox</h4>
                                            {/* <a href="#" className="new-message"><i className="icon md-plus" />New message</a> */}
                                        </div>
                                        <div className="list-wrap ps-container ps-active-y"><ul className="list-message">
                                            {/* LIST ITEM */}
                                            {inbox?.inbox?.data.length==0&&<h4 className="black m-6">No Message</h4>}
                                            {inbox?.inbox?.data?.map((item, index) => {
                                                if (item?.is_read == 0) {
                                                    return (
                                                        <li className="ac-new">
                                                            <a className="cursor-pointer" onClick={() => showMessage(item)}>
                                                                <div className="image">
                                                                    <img src={item?.send_by?.image?process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + item?.send_by?.image: item?.send_by?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
                                                                </div>
                                                                <div className="list-body">
                                                                    <div className="author">
                                                                        <span>{item?.send_by?.first_name} {item?.send_by?.last_name}</span>
                                                                        <div className="div-x" />
                                                                    </div>
                                                                    <p>{item?.description.slice(0, 30)}...</p>
                                                                    <div className="time">
                                                                        <span>{moment(item?.created_at).fromNow()}</span>
                                                                    </div>
                                                                    <div className="indicator">
                                                                        <i className="icon mdi  mdi-paperclip" />
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>)
                                                }
                                                else {
                                                    return (
                                                        <li className="active">
                                                            <a className="cursor-pointer" onClick={() => showMessage(item)}>
                                                                <div className="image">
                                                                    <img src={item?.send_by?.image?process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + item?.send_by?.image: item?.send_by?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
                                                                </div>
                                                                <div className="list-body">
                                                                    <div className="author">
                                                                        <span>{item?.send_by?.first_name} {item?.send_by?.last_name}</span>
                                                                        <div className="div-x" />
                                                                    </div>
                                                                    <p>{item?.description.slice(0, 30)}...</p>
                                                                    <div className="time">
                                                                        <span>{moment(item?.created_at).fromNow()}</span>
                                                                    </div>
                                                                    <div className="indicator">
                                                                        <i className="icon md-paperclip" />
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>)
                                                }
                                            }
                                            )}
                                        </ul><div className="ps-scrollbar-x-rail" style={{ width: '423px', display: 'none', left: '0px' }}><div className="ps-scrollbar-x" style={{ left: '0px', width: '0px' }} /></div><div className="ps-scrollbar-y-rail" style={{ top: '0px', height: '440px', display: 'inherit', right: '0px' }}><div className="ps-scrollbar-y" style={{ top: '0px', height: '150px' }} /></div></div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    {message?.description &&
                                        <div id="message-ct" className="message-ct">
                                            <div className="author">
                                                <div className="image">
                                                    <img src={message?.send_by?.image?process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + message?.send_by?.image: message?.send_by?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
                                                </div>
                                                <span className="author-name">{message?.send_by?.first_name} {message?.send_by?.last_name}</span>
                                                <em>{moment(message?.created_at).fromNow()}</em>
                                            </div>
                                            <p>{message?.description}</p>
                                            {inbox?.inbox?.data.length==0&&<h4 className="black m-6">No Message</h4>}
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer setting={page?.setting} />
            </div>
        </div>
    );
};

export default Inbox;